import { mobile_max_width } from "@assets/constants/styles/media";
import { useMediaQuery } from "usehooks-ts";

export const useMobileQuery = () => useMediaQuery(mobile_max_width);